$( document ).ready(function() {
    // Why Kwanko
        $('.main.order_left').on('mouseover', function(){
            $('.hover').addClass('d-none');
            $('.hover.order_left').removeClass('d-none');
        });
        $('.main.order_top_left').on('mouseover', function(){
            $('.hover').addClass('d-none');
            $('.hover.order_top_left').removeClass('d-none');
        });
        $('.main.order_top').on('mouseover', function(){
            $('.hover').addClass('d-none');
            $('.hover.order_top').removeClass('d-none');
        });
        $('.main.order_top_right').on('mouseover', function(){
            $('.hover').addClass('d-none');
            $('.hover.order_top_right').removeClass('d-none');
        });
        $('.main.order_right').on('mouseover', function(){
            $('.hover').addClass('d-none');
            $('.hover.order_right').removeClass('d-none');
        });
        $('.main.order_bottom_right').on('mouseover', function(){
            $('.hover').addClass('d-none');
            $('.hover.order_bottom_right').removeClass('d-none');
        });
        $('.main.more').on('mouseover', function(){
            $('.hover').addClass('d-none');
            $('.hover.more').removeClass('d-none');
        });
        $('.main.order_bottom_left').on('mouseover', function(){
            $('.hover').addClass('d-none');
            $('.hover.order_bottom_left').removeClass('d-none');
        });
    // Channels
        $('#advertisers_seemore').on('click', function(){
            $(this).addClass('d-none');
            $('.cannels-more').css('height','0px');
            $('.hidden').removeClass('d-none');
        });
    // FAQ
        $('.faq-question').on('click', function(){
            $(this).toggleClass("closed open");
            $(this).siblings('.faq-answer').toggleClass("closed open");
        })
    // ROI Slider
        $("#monthly_budget").slider();
        $("#monthly_budget").on("change", function(slideEvt) {
            $num = slideEvt.value.newValue
            $output = $num.toLocaleString('pt')
            $("#budget_amount").text('€ ' + $output)
            $("input[name='monthly_budget']").val(slideEvt.value.newValue)
            $old_url = $('#monthly_budget_roi').attr('href')
            $remove_budget = $old_url.split('=')[0]
            $new_url = $remove_budget + '=' + $("input[name='monthly_budget']").val()
            $('#monthly_budget_roi').attr('href', $new_url)
        });
        // ROI more and less buttons
            $('#less-budget').on('click', function(){
                if($("input[name='monthly_budget']").val() > 1){
                    $current_budget = $("input[name='monthly_budget']").val()
                    $("input[name='monthly_budget']").val(parseInt($current_budget) - 1)
                    $output = parseInt($current_budget)
                    $output_final = $output.toLocaleString('pt')
                    $("#budget_amount").text('€ ' + $output_final)
                    $('#monthly_budget').slider('setValue', parseInt($current_budget) - 1)
                    $old_url = $('#monthly_budget_roi').attr('href')
                    $remove_budget = $old_url.split('=')[0]
                    $new_url = $remove_budget + '=' + $("input[name='monthly_budget']").val()
                    $('#monthly_budget_roi').attr('href', $new_url)
                }
            })
            $('#more-budget').on('click', function(){
                if($("input[name='monthly_budget']").val() < 20000){
                    $current_budget = $("input[name='monthly_budget']").val()
                    $("input[name='monthly_budget']").val(parseInt($current_budget) + 1)
                    $output = parseInt($current_budget)
                    $output_final = $output.toLocaleString('pt')
                    $("#budget_amount").text('€ ' + $output_final)
                    $('#monthly_budget').slider('setValue', parseInt($current_budget) + 1)
                    $old_url = $('#monthly_budget_roi').attr('href')
                    $remove_budget = $old_url.split('=')[0]
                    $new_url = $remove_budget + '=' + $("input[name='monthly_budget']").val()
                    $('#monthly_budget_roi').attr('href', $new_url)
                }
            })
        // ROI Monthly Budget Button
            $('.btn-home_calculate').on('click', function(){
                $('#monthly_budget_roi').attr('href', $('#monthly_budget_roi').attr('href') + '?budget=' + $('[name="monthly_budget"]').val());
            });
});